<template>
  <q-dialog
    :visible="isVisible"
    :title="title"
    width="450px"
    :innerScroll="false"
    :loading="loadingButtom"
    @close="onCancel"
    @cancel="onCancel"
    @confirm="onConfirm"
  >
    <el-form :model="addForm" ref="addForm" :rules="rules" size="small" label-width="100px">
      <el-form-item label="用户" v-if="!rowData" prop="userId">
        <el-select
          v-model="userId"
          filterable
          remote
          placeholder="请输入关键词"
          :remote-method="remoteMethod"
          :loading="loading"
          @change="handleUserInfoChange"
        >
          <el-option v-for="item in userList" :key="item.userId" :label="`${item.userName}-${item.workNo}`" :value="item.userId">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="用户" v-else>
        {{ addForm.userName + "-" + addForm.workNo }}
      </el-form-item>
      <el-form-item label="岗位">
        <span>{{ addForm.workJobs }}</span>
      </el-form-item>
      <el-form-item label="店铺全称" prop="storeCodeList">
        <el-select v-model="addForm.storeCodeList" filterable multiple collapse-tags placeholder="请选择" @change="storeCodeChange">
          <el-option label="全部" value="" v-show="!all"></el-option>
          <el-option v-if="all" label="取消所有" value="cancleAll"></el-option>
          <el-option v-for="item in authOptions" :key="item.storeCode" :label="item.fullName" :value="item.storeCode"> </el-option>
        </el-select>
      </el-form-item>
    </el-form>
  </q-dialog>
</template>

<script>
import axios from "@/utils/axiosInstance";
export default {
  props: {
    // 重新对外暴露visible，控制显示隐藏
    visible: {
      type: Boolean,
      default: false,
    },
    authOptions: {
      type: Array,
      default: [],
    },
    rowData: Object,
  },
  data() {
    return {
      addForm: {
        storeCodeList: []
      },
      userId: "",
      userList: [],
      all: false,
      rules: {
        userId: [{ required: true, message: "不能为空", trigger: "blur" }],
        storeCodeList: [{ required: true, message: "不能为空", trigger: "change" }],
      },
      loading: false,
      loadingButtom: false,
      currencyForm: {
        pageSize: 999999,
        pageNum: 1,
        reportCode: "",
        param: {},
        queryMatch: [
          // {
          //   attributeName: '',
          //   val: {},
          //   op: ''
          // }
        ],
        orderList: [
          // {
          //   attributeName: '',
          //   type: ''
          // }
        ],
        orderType: "",
        hasCount: "N",
        groupAttr: "",
      },
    };
  },
  watch: {
    storeCodeList(val,old) {
      if(!val || !val.length) return
      this.all = val.length != this.authOptions.length ? false : true
    },
  },
  computed: {
    // 通过计算属性，对.sync进行转换，外部也可以直接使用visible.sync
    isVisible: {
      get() {
        return this.visible;
      },
      set(val) {
        this.$emit("update:visible", val);
      },
    },
    title() {
      return this.rowData ? "编辑" : "新增";
    },
    storeCodeList() {
      return this.addForm.storeCodeList ? JSON.parse(JSON.stringify(this.addForm.storeCodeList)) : []
    },
  },
  mounted() {
    if (this.rowData) {
      let addForm = JSON.parse(JSON.stringify(this.rowData));
      addForm["storeCodeList"] = addForm["storeCode"] && addForm["storeCode"].split(",");
      this.addForm = addForm;
    }
  },
  methods: {
    onCancel() {
      this.isVisible = false;
    },
    onConfirm() {
      this.$refs.addForm.validate((valid) => {
        if (!valid) return;
        this.loadingButtom = true;
        let data = {
          ...this.addForm,
        };
        this.$q.qualityTestingManage
          .teamLeaderSaveOrUpdate({ data: data })
          .then((res) => {
            if (res.code == 200) {
              let text = this.title + "成功";
              this.$message.success(text);
              this.isVisible = false;
              this.$emit("success");
            }
          })
          .finally((_) => {
            this.loadingButtom = false;
          });
      });
    },
    remoteMethod(query) {
      this.loading = true;
      let currencyForm = JSON.parse(JSON.stringify(this.currencyForm));
      currencyForm.reportCode = "searchUserInfoByName";
      currencyForm.pageSize = 100;
      currencyForm.param = {
        userName: query,
      };
      axios.post(`/ec-pc-api/custom/reports/data/searchUserInfoByName`, currencyForm).then((res) => {
        if (res.code == 200) {
          this.userList = res.data.list;
          this.loading = false;
        }
      });
    },
    handleUserInfoChange(data) {
      const activeObj = this.userList.find((v) => v.userId === this.userId);
      this.$set(this.addForm,'userId',activeObj.userId)
      this.$set(this.addForm,'workNo',activeObj.workNo)
      this.$set(this.addForm,'userName',activeObj.userName)
      this.$set(this.addForm,'workJobs',activeObj.workJobs)
    },
    storeCodeChange(val) {
      if (val.includes("")) {
        this.addForm.storeCodeList = this.authOptions.map((v) => v.storeCode);
        this.all = true;
      } else if (val.includes("cancleAll")) {
        this.addForm.storeCodeList = [];
        this.all = false;
      }
    },
  },
};
</script>

<style lang="stylus" scoped>
>>> .el-input--small .el-input__inner, >>> .el-date-editor.el-input, >>> .el-date-editor.el-input__inner
  width 220px !important
>>> .el-input
  width 220px !important

>>> .el-select__tags-text {
display: inline-block;
max-width: 60px;
overflow: hidden;
text-overflow: ellipsis;
white-space: nowrap;
}
>>> .el-tag__close.el-icon-close {
  top: 0px;
  right: -4px
}
</style>
